export const createList = [
    { id: 1, name: "Photo Video Maker"},
    { id: 2, name: "Facebook Video Maker"},
    { id: 3, name: "YouTube Intro Maker"},
    { id: 4, name: "Instagram Video Maker"},
    { id: 5, name: "Instagram Story Maker"},
    { id: 6, name: "Promo Video Maker"},
    { id: 7, name: "Video Ad Maker"},
    { id: 8, name: "Marketing Video Maker"}
];

export const createList2 = [
    { id: 9, name: "LinkedIn Video Maker" },
    { id: 10, name: " Business Video Maker" },
    { id: 11, name: "Ecommerce Video Maker" },
    { id: 12, name: "Explainer Video Maker" },
    { id: 13, name: "Slideshow Maker" },
    { id: 14, name: "Education Video Maker" },
    { id: 15, name: "Video Editor" },
    { id: 16, name: "Voiceover" }
];




      
                 
                  
                  
                  
                  
                  
                  
                  
                  
                  
                  
                  
                  
                  